var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 524,
    height: 316,
    viewBox: "0 0 524 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_2296)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M130.598 76.0443C108.502 83.6347 84.5166 96.1023 78.8362 118.765C75.5875 131.737 79.1234 145.915 74.5727 158.479C68.12 176.277 47.4728 185.655 40.2797 203.166C37.2417 210.571 36.9098 218.787 37.197 226.786C37.7331 241.794 40.7201 257.581 50.6704 268.83C65.8223 285.977 91.6266 287.343 114.495 287.458C233.634 287.943 352.774 287.392 471.913 285.804C476.508 285.741 481.531 285.53 485.003 282.51C487.492 280.346 488.731 277.09 489.611 273.911C494.545 256.075 491.36 235.876 500.666 219.879C505.306 211.905 512.658 205.802 517.464 197.931C528.232 180.292 523.975 156.436 511.816 139.755C499.657 123.074 481.046 112.304 462.218 103.782C443.39 95.2596 423.642 88.4991 406.193 77.4487C372.493 56.0182 348.559 19.3558 311.011 5.78375C278.46 -6.00082 241.978 3.53663 214.636 23.301C203.045 31.6766 194.091 42.7909 182.953 51.6197C167.444 63.8958 149.011 69.7179 130.598 76.0443Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M11.508 293.446C7.15512 293.695 2.03001 294.416 0.0195312 298.278C5.76375 303.935 14.3801 305.301 22.3964 306.252C66.4737 311.442 110.953 312.227 155.362 313.012L288.609 315.342C316.411 315.834 344.398 316.306 371.817 311.685C389.196 308.754 406.231 303.794 423.745 301.841C440.479 299.97 457.438 300.87 474.166 298.891C478.327 298.4 482.68 297.615 485.948 295.01C489.216 292.405 490.875 287.305 488.463 283.877C486.548 281.183 482.999 280.391 479.757 279.861C467.63 277.895 455.395 276.835 443.147 276.088C329.342 269.092 216.206 288.192 102.579 290.031C72.0775 290.529 41.9906 291.69 11.508 293.446Z",
    fill: "#1D3441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.009 134.82C107.009 134.82 109.932 113.224 111.636 109.649C113.34 106.074 113.774 91.04 133.266 101.222C133.266 101.222 136.126 104.108 134.67 107.664C133.215 111.219 133.356 113.779 134.345 115.062C135.334 116.346 132.602 117.705 132.602 117.705C132.602 117.705 131.964 117.488 131.09 121.625C130.215 125.762 122.212 125.5 122.212 125.5C122.212 125.5 117.916 127.696 118.95 134.073C119.984 140.451 109.013 139.787 107.009 134.82Z",
    fill: "url(#paint0_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.796 111.545C105.515 107.963 106.434 104.12 108.987 101.611C109.45 101.225 109.877 100.798 110.263 100.335C110.607 99.7603 110.888 99.1503 111.1 98.5153C111.786 96.9606 112.808 95.5767 114.091 94.4622C115.374 93.3477 116.887 92.5301 118.522 92.0676C121.828 91.179 125.345 91.5239 128.415 93.0379C129.992 93.7976 131.44 94.819 133.074 95.4446C134.708 96.0703 136.655 96.2426 138.142 95.317C138.277 95.7493 138.304 96.2082 138.22 96.6533C138.137 97.0985 137.946 97.5164 137.663 97.8705L139.942 97.13C140.002 98.4759 139.711 99.8144 139.097 101.013C138.482 102.212 137.566 103.23 136.438 103.967L137.325 103.833C136.604 105.014 134.906 105.014 133.553 104.759C131.842 104.445 130.168 103.957 128.556 103.303C126.315 102.397 123.679 101.184 121.643 102.499C119.607 103.814 119.626 106.77 118.975 109.132C118.524 110.779 117.643 112.278 116.422 113.473C116.263 112.653 115.944 111.872 115.484 111.174C115.25 110.827 114.923 110.553 114.541 110.383C114.158 110.214 113.735 110.156 113.321 110.217C111.904 110.549 111.604 112.438 111.789 113.881C111.948 115.158 112.427 116.601 113.64 117.009C112.317 118.716 111.27 120.621 110.538 122.653L109.836 122.429C109.761 122.605 109.62 122.745 109.443 122.818C109.267 122.89 109.068 122.891 108.891 122.819C108.253 122.538 107.519 118.809 107.251 118.012C106.503 115.923 106.015 113.752 105.796 111.545Z",
    fill: "#3D4D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.065 294.499C228.85 294.499 231.919 291.429 231.919 287.643C231.919 283.856 228.85 280.787 225.065 280.787C221.279 280.787 218.21 283.856 218.21 287.643C218.21 291.429 221.279 294.499 225.065 294.499Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.511 287.643C228.511 288.325 228.309 288.992 227.93 289.559C227.551 290.126 227.012 290.568 226.382 290.829C225.752 291.089 225.059 291.157 224.39 291.024C223.721 290.89 223.107 290.561 222.625 290.078C222.144 289.596 221.816 288.981 221.684 288.312C221.551 287.643 221.621 286.949 221.882 286.319C222.144 285.69 222.587 285.152 223.155 284.774C223.722 284.396 224.389 284.195 225.071 284.196C225.984 284.197 226.859 284.561 227.504 285.208C228.149 285.854 228.511 286.73 228.511 287.643Z",
    fill: "url(#paint1_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.611 294.499C271.396 294.499 274.465 291.429 274.465 287.643C274.465 283.856 271.396 280.787 267.611 280.787C263.825 280.787 260.756 283.856 260.756 287.643C260.756 291.429 263.825 294.499 267.611 294.499Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.61 291.084C269.51 291.084 271.05 289.543 271.05 287.643C271.05 285.743 269.51 284.202 267.61 284.202C265.71 284.202 264.17 285.743 264.17 287.643C264.17 289.543 265.71 291.084 267.61 291.084Z",
    fill: "url(#paint2_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.094 294.499C420.88 294.499 423.949 291.429 423.949 287.643C423.949 283.856 420.88 280.787 417.094 280.787C413.308 280.787 410.239 283.856 410.239 287.643C410.239 291.429 413.308 294.499 417.094 294.499Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.093 291.084C418.993 291.084 420.534 289.543 420.534 287.643C420.534 285.743 418.993 284.202 417.093 284.202C415.194 284.202 413.653 285.743 413.653 287.643C413.653 289.543 415.194 291.084 417.093 291.084Z",
    fill: "url(#paint3_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.633 294.499C463.419 294.499 466.488 291.429 466.488 287.643C466.488 283.856 463.419 280.787 459.633 280.787C455.847 280.787 452.778 283.856 452.778 287.643C452.778 291.429 455.847 294.499 459.633 294.499Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.633 291.084C461.532 291.084 463.073 289.543 463.073 287.643C463.073 285.743 461.532 284.202 459.633 284.202C457.733 284.202 456.192 285.743 456.192 287.643C456.192 289.543 457.733 291.084 459.633 291.084Z",
    fill: "url(#paint4_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.08 132.637C187.312 131.673 188.965 131.443 190.299 130.639C190.937 130.262 191.461 129.77 192.067 129.362C193.59 128.276 195.374 127.615 197.237 127.447C197.543 128.009 195.858 129.432 195.15 129.828C197.703 129.566 199.337 129.304 201.915 129.19C202.949 129.19 202.636 130.007 202.241 130.179C201.519 130.498 199.349 131.117 198.628 131.456C200.344 130.842 202.127 130.433 203.938 130.237C204.704 130.358 204.385 131.181 203.855 131.373C201.984 132.133 200.065 132.773 198.111 133.288C199.432 133.045 201.264 132.503 202.579 132.496C202.676 132.494 202.77 132.523 202.849 132.579C202.928 132.635 202.987 132.715 203.016 132.807C203.046 132.899 203.045 132.998 203.013 133.089C202.981 133.181 202.921 133.259 202.841 133.314C202.419 133.592 201.959 133.807 201.475 133.952L198.015 135.229C199.115 135.052 200.227 134.971 201.341 134.986C202.024 135.037 202.215 135.746 200.511 136.32C199.007 136.769 197.54 137.337 196.126 138.018C192.973 139.653 189.189 139.123 185.685 138.555C185.889 136.531 185.895 134.616 186.08 132.637Z",
    fill: "url(#paint5_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5784 278.827L25.3509 280.793C25.2083 280.913 25.0921 281.06 25.0098 281.227C24.9276 281.394 24.8811 281.576 24.8732 281.761C24.8654 281.947 24.8965 282.132 24.9645 282.305C25.0324 282.478 25.1358 282.635 25.2679 282.766L29.2059 286.839C29.5121 287.141 29.9203 287.318 30.3502 287.334C30.7801 287.351 31.2006 287.206 31.5291 286.928L33.7247 285.013L27.5784 278.827Z",
    fill: "url(#paint6_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.761 276.746L135.257 280.218C135.233 280.45 135.257 280.685 135.325 280.908C135.394 281.131 135.506 281.338 135.656 281.516C135.806 281.695 135.991 281.841 136.198 281.948C136.406 282.054 136.633 282.117 136.865 282.134L144.244 283.136C144.767 283.224 145.303 283.108 145.744 282.813C146.184 282.517 146.495 282.064 146.611 281.546L147.135 278.15L135.761 276.746Z",
    fill: "url(#paint7_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6913 199.38C82.8128 198.742 79.9088 200.363 79.3471 202.987C77.075 213.597 78.3578 237.734 67.2204 244.437C56.083 251.14 34.1976 268.785 28.5682 275.801C27.8528 276.65 27.4965 277.745 27.5752 278.852C27.6538 279.959 28.1612 280.993 28.9895 281.732L31.1149 283.723C31.9147 284.44 32.9043 284.911 33.965 285.08C35.0257 285.249 36.1125 285.108 37.0952 284.675C47.7986 279.957 80.496 265.089 86.1061 256.95C92.8524 247.182 117.438 209.633 117.438 208.107C117.463 206.92 96.0053 201.787 85.6913 199.38Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6913 199.38C82.8128 198.742 79.9088 200.363 79.3471 202.987C77.075 213.597 78.3578 237.734 67.2204 244.437C56.083 251.14 34.1976 268.785 28.5683 275.801C27.8528 276.65 27.4965 277.745 27.5752 278.852C27.6538 279.959 28.1612 280.993 28.9895 281.732L31.1149 283.723C31.9147 284.44 32.9043 284.912 33.965 285.08C35.0257 285.249 36.1125 285.108 37.0952 284.675C47.7986 279.957 80.496 265.089 86.1061 256.95C92.8524 247.182 117.438 209.633 117.438 208.107C117.463 206.92 96.0053 201.787 85.6913 199.38Z",
    fill: "url(#paint8_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.153 149.637C131.153 149.637 154.2 150.575 169.039 145.807C183.879 141.038 186.272 139.423 186.272 139.423L185.519 132.35C185.519 132.35 159.076 137.604 150.269 135.81C141.461 134.016 130.023 139.372 130.023 139.372L131.153 149.637Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.153 149.637C131.153 149.637 154.2 150.575 169.039 145.807C183.879 141.038 186.272 139.423 186.272 139.423L185.519 132.35C185.519 132.35 159.076 137.604 150.269 135.81C141.461 134.016 130.023 139.372 130.023 139.372L131.153 149.637Z",
    fill: "url(#paint9_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.377 38.3796V200.235C499.377 202.343 498.962 204.429 498.155 206.376C497.349 208.323 496.167 210.092 494.677 211.581C493.187 213.071 491.418 214.253 489.471 215.059C487.524 215.865 485.438 216.279 483.331 216.278H204.667C200.412 216.278 196.332 214.588 193.323 211.58C190.314 208.571 188.623 204.491 188.621 200.235V38.3796C188.621 34.1231 190.312 30.041 193.321 27.0312C196.33 24.0215 200.411 22.3306 204.667 22.3306H483.306C485.415 22.3264 487.505 22.7385 489.455 23.5432C491.405 24.3479 493.177 25.5295 494.67 27.0203C496.163 28.5111 497.347 30.2818 498.155 32.231C498.962 34.1802 499.378 36.2696 499.377 38.3796Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.377 38.3796V200.235C499.377 202.343 498.962 204.429 498.155 206.376C497.349 208.323 496.167 210.092 494.677 211.581C493.187 213.071 491.418 214.253 489.471 215.059C487.524 215.865 485.438 216.279 483.331 216.278H204.667C200.412 216.278 196.332 214.588 193.323 211.58C190.314 208.571 188.623 204.491 188.621 200.235V38.3796C188.621 34.1231 190.312 30.041 193.321 27.0312C196.33 24.0215 200.411 22.3306 204.667 22.3306H483.306C485.415 22.3264 487.505 22.7385 489.455 23.5432C491.405 24.3479 493.177 25.5295 494.67 27.0203C496.163 28.5111 497.347 30.2818 498.155 32.231C498.962 34.1802 499.378 36.2696 499.377 38.3796Z",
    fill: "url(#paint10_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.884 14.3765H205.598C202.08 14.3765 199.229 17.2289 199.229 20.7475V40.6332C199.229 44.1518 202.08 47.0043 205.598 47.0043H479.884C483.402 47.0043 486.254 44.1518 486.254 40.6332V20.7475C486.254 17.2289 483.402 14.3765 479.884 14.3765Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.884 14.3765H205.598C202.08 14.3765 199.229 17.2289 199.229 20.7475V40.6332C199.229 44.1518 202.08 47.0043 205.598 47.0043H479.884C483.402 47.0043 486.254 44.1518 486.254 40.6332V20.7475C486.254 17.2289 483.402 14.3765 479.884 14.3765Z",
    fill: "url(#paint11_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.376 38.6671V200.523C499.376 204.779 497.686 208.862 494.677 211.871C491.668 214.881 487.586 216.572 483.331 216.572L215.299 216.278C211.045 216.278 206.965 214.588 203.956 211.58C200.947 208.572 199.256 204.491 199.254 200.236V38.6671C199.254 34.4107 200.944 30.3286 203.954 27.3188C206.963 24.309 211.044 22.6182 215.299 22.6182H483.363C487.613 22.6249 491.687 24.319 494.69 27.3282C497.692 30.3374 499.378 34.4157 499.376 38.6671Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.376 38.6667V200.523C499.376 204.779 497.686 208.861 494.677 211.871C491.667 214.881 487.586 216.572 483.331 216.572L215.299 216.278C206.44 216.278 199.254 209.096 195.073 201.365V39.7839C199.254 29.7868 206.44 22.605 215.299 22.605H483.363C487.615 22.6117 491.691 24.3076 494.694 27.3195C497.697 30.3315 499.381 34.4131 499.376 38.6667Z",
    fill: "url(#paint12_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6877 135.312C99.6877 135.312 104.845 128.513 120.073 128.583C135.302 128.654 148.839 128.826 152.713 127.562C156.587 126.298 179.207 118.095 179.207 118.095L182.475 126.7C182.475 126.7 161.476 139.315 151.539 141.383C139.508 143.892 130.521 147.128 127.285 158.026C124.05 168.923 122.652 190.89 118.114 195.052C113.576 199.214 83.6485 205.713 80.3297 198.531C77.0108 191.349 84.5166 160.26 99.6877 135.312Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.475 126.7C182.475 126.7 179.922 128.213 176.246 130.281C169.225 134.176 158.037 140.036 151.539 141.389C139.508 143.898 130.522 147.135 127.286 158.032C124.299 167.991 122.901 187.244 119.206 193.609C118.915 194.135 118.547 194.615 118.114 195.033C113.583 199.169 83.649 205.694 80.3301 198.512C77.0112 191.33 84.5553 160.26 99.72 135.312C99.72 135.312 104.877 128.513 120.106 128.583C135.334 128.654 148.871 128.826 152.745 127.562C156.62 126.298 179.239 118.095 179.239 118.095L182.475 126.7Z",
    fill: "url(#paint13_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2973 198.155C80.2973 198.155 75.9125 213.514 86.5649 218.755C97.2172 223.996 137.044 231.638 137.044 231.638C137.044 231.638 130.08 260.001 132.372 271.218L133.259 275.578C133.454 276.361 133.903 277.059 134.536 277.561C135.168 278.063 135.949 278.342 136.757 278.355L145.36 278.802C146.103 278.859 146.847 278.698 147.5 278.338C148.153 277.979 148.687 277.436 149.036 276.778C153.74 267.202 163.078 229.25 154.934 218.736C145.603 206.709 118.081 195.014 118.081 195.014L80.2973 198.155Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.164 276.529L149.036 276.797C148.759 277.33 148.357 277.788 147.865 278.132C147.372 278.476 146.805 278.697 146.209 278.776C145.928 278.82 145.644 278.835 145.36 278.82L143.758 278.737L136.737 278.374C135.93 278.361 135.149 278.082 134.517 277.58C133.884 277.078 133.435 276.38 133.24 275.597L132.385 271.236C130.093 260.001 137.057 231.657 137.057 231.657C137.057 231.657 97.2364 223.996 86.5777 218.774C75.919 213.552 80.3102 198.173 80.3102 198.173L93.9942 197.044L118.094 195.052C118.094 195.052 145.616 206.747 154.947 218.774C163.02 229.173 153.906 266.506 149.164 276.529Z",
    fill: "url(#paint14_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.164 276.312L146.209 278.54L145.571 279.025C144.934 278.997 144.312 278.817 143.758 278.501C143.332 278.269 142.961 277.947 142.67 277.558C142.38 277.169 142.176 276.722 142.073 276.248L141.186 271.888C140.19 267.011 146.605 247.629 147.766 239.969C148.542 234.829 147.339 229.586 144.399 225.299C141.46 221.012 137.005 218 131.932 216.872C120.245 214.248 106.631 210.839 101.04 208.094C96.0813 205.655 94.3835 201.021 93.9814 196.763L118.082 194.771C118.082 194.771 145.603 206.466 154.934 218.493C163.021 228.956 153.906 266.289 149.164 276.312Z",
    fill: "url(#paint15_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.853 282.14C136.853 282.14 132.468 294.014 133.362 295.042C134.255 296.07 169.02 295.042 169.02 295.042C169.02 295.042 170.654 291.85 162.823 289.424C154.992 286.998 145.871 286.347 145.871 286.347L144.231 283.155L136.853 282.14ZM25.2682 282.766L18.7262 285.121L17.0986 287.324L30.1508 299.606H45.3283C45.3283 299.606 43.3688 293.701 37.497 293.433C31.6251 293.165 29.1998 286.851 29.1998 286.851L25.2682 282.766Z",
    fill: "#225672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.615 118.944C180.407 117.597 181.868 116.786 182.806 115.554C183.253 114.973 183.579 114.322 183.994 113.722C185.01 112.147 186.429 110.873 188.104 110.032C188.595 110.44 187.536 112.381 187.025 113.007C189.323 111.832 190.733 110.996 193.082 109.93C194.059 109.585 194.052 110.434 193.752 110.734C193.197 111.296 191.397 112.649 190.836 113.217C192.215 112.023 193.729 110.994 195.348 110.153C196.101 109.993 196.101 110.874 195.68 111.245C194.218 112.638 192.668 113.937 191.04 115.132C192.182 114.424 193.695 113.256 194.946 112.764C195.031 112.735 195.123 112.732 195.21 112.756C195.297 112.78 195.375 112.83 195.433 112.899C195.491 112.968 195.527 113.053 195.535 113.143C195.544 113.233 195.526 113.323 195.482 113.402C195.194 113.822 194.845 114.196 194.448 114.513L191.678 116.945C192.642 116.385 193.652 115.906 194.697 115.515C195.335 115.311 195.782 115.905 194.403 117.06C193.162 118.029 192.001 119.097 190.931 120.252C188.589 122.914 184.868 123.795 181.396 124.536C180.892 122.64 180.177 120.859 179.615 118.944Z",
    fill: "url(#paint16_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.85 282.485C242.904 282.485 238.915 278.476 238.915 274.824V228.943C238.915 222.694 242.93 218.678 247.85 218.678C250.22 218.678 252.493 219.62 254.169 221.296C255.845 222.972 256.786 225.245 256.786 227.616V273.496C256.793 274.674 256.567 275.842 256.12 276.932C255.674 278.022 255.017 279.014 254.187 279.849C253.357 280.684 252.369 281.347 251.282 281.8C250.194 282.252 249.028 282.485 247.85 282.485ZM437.627 282.485C435.257 282.485 432.984 281.543 431.308 279.867C429.633 278.191 428.691 275.918 428.691 273.547V227.641C428.691 225.271 429.633 222.998 431.308 221.321C432.984 219.645 435.257 218.704 437.627 218.704C439.996 218.704 442.269 219.645 443.945 221.321C445.621 222.998 446.562 225.271 446.562 227.641V273.522C446.565 274.698 446.337 275.863 445.889 276.95C445.442 278.037 444.784 279.025 443.954 279.858C443.124 280.691 442.138 281.351 441.052 281.802C439.966 282.253 438.802 282.485 437.627 282.485Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.85 282.485C242.904 282.485 238.915 278.476 238.915 274.824V228.943C238.915 222.694 242.93 218.678 247.85 218.678C250.22 218.678 252.493 219.62 254.169 221.296C255.845 222.972 256.786 225.245 256.786 227.616V273.496C256.793 274.674 256.567 275.842 256.12 276.932C255.674 278.022 255.017 279.014 254.187 279.849C253.357 280.684 252.369 281.347 251.282 281.8C250.194 282.252 249.028 282.485 247.85 282.485Z",
    fill: "url(#paint17_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.626 282.485C435.256 282.485 432.983 281.543 431.308 279.867C429.632 278.191 428.69 275.918 428.69 273.548V227.641C428.69 225.271 429.632 222.998 431.308 221.322C432.983 219.646 435.256 218.704 437.626 218.704C439.996 218.704 442.268 219.646 443.944 221.322C445.62 222.998 446.561 225.271 446.561 227.641V273.522C446.565 274.698 446.336 275.863 445.888 276.95C445.441 278.037 444.783 279.026 443.953 279.858C443.123 280.691 442.137 281.352 441.051 281.802C439.965 282.253 438.801 282.485 437.626 282.485Z",
    fill: "url(#paint18_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.655 283.487H219.129C218.569 283.487 218.032 283.265 217.635 282.868C217.239 282.472 217.017 281.935 217.017 281.374C217.017 280.814 217.239 280.276 217.635 279.88C218.032 279.484 218.569 279.261 219.129 279.261H273.655C274.215 279.261 274.752 279.484 275.148 279.88C275.545 280.276 275.767 280.814 275.767 281.374C275.767 281.935 275.545 282.472 275.148 282.868C274.752 283.265 274.215 283.487 273.655 283.487ZM465.626 283.487H411.101C410.541 283.487 410.003 283.265 409.607 282.868C409.211 282.472 408.988 281.935 408.988 281.374C408.988 280.814 409.211 280.276 409.607 279.88C410.003 279.484 410.541 279.261 411.101 279.261H465.626C466.186 279.261 466.724 279.484 467.12 279.88C467.516 280.276 467.739 280.814 467.739 281.374C467.739 281.935 467.516 282.472 467.12 282.868C466.724 283.265 466.186 283.487 465.626 283.487Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.626 283.487H411.101C410.541 283.487 410.003 283.265 409.607 282.868C409.211 282.472 408.988 281.935 408.988 281.374C408.988 280.814 409.211 280.276 409.607 279.88C410.003 279.484 410.541 279.261 411.101 279.261H465.626C466.187 279.261 466.724 279.484 467.12 279.88C467.516 280.276 467.739 280.814 467.739 281.374C467.739 281.935 467.516 282.472 467.12 282.868C466.724 283.265 466.187 283.487 465.626 283.487Z",
    fill: "url(#paint19_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.655 283.487H219.129C218.569 283.487 218.032 283.265 217.635 282.868C217.239 282.472 217.017 281.935 217.017 281.374C217.017 280.814 217.239 280.276 217.635 279.88C218.032 279.484 218.569 279.261 219.129 279.261H273.655C274.215 279.261 274.752 279.484 275.148 279.88C275.545 280.276 275.767 280.814 275.767 281.374C275.767 281.935 275.545 282.472 275.148 282.868C274.752 283.265 274.215 283.487 273.655 283.487Z",
    fill: "url(#paint20_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.596 127.583V124.427C296.597 124.164 296.547 123.903 296.447 123.659C296.348 123.416 296.201 123.194 296.015 123.007C295.83 122.82 295.609 122.672 295.366 122.571C295.123 122.47 294.862 122.418 294.598 122.418H250.36C249.638 122.418 248.946 122.131 248.436 121.622C247.926 121.112 247.64 120.42 247.64 119.699V115.459C247.64 114.738 247.926 114.046 248.436 113.536C248.946 113.026 249.638 112.74 250.36 112.74H294.78C295.309 112.74 295.816 112.53 296.191 112.157C296.566 111.783 296.777 111.277 296.779 110.748V107.323C296.78 106.983 296.869 106.648 297.036 106.35C297.203 106.053 297.444 105.804 297.735 105.626C298.026 105.448 298.358 105.348 298.699 105.335C299.04 105.322 299.378 105.396 299.682 105.551C299.721 105.57 299.757 105.593 299.791 105.619L312.981 115.484C313.296 115.657 313.559 115.912 313.741 116.222C313.924 116.532 314.019 116.885 314.017 117.244C314.015 117.603 313.917 117.956 313.731 118.264C313.546 118.572 313.281 118.824 312.964 118.994L299.595 129.311C299.556 129.341 299.513 129.368 299.469 129.39C299.164 129.539 298.825 129.607 298.486 129.589C298.146 129.571 297.817 129.466 297.529 129.285C297.242 129.105 297.005 128.853 296.842 128.555C296.678 128.257 296.594 127.923 296.596 127.583Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.392 38.8393C204.392 38.8393 204.858 26.0716 219.627 25.063H253.084C253.084 25.063 233.771 28.1272 231.92 38.8393C230.069 49.5514 231.92 195.32 231.92 195.32C231.92 195.32 234.645 212.384 260.756 213.239H215.274C215.274 213.239 205.152 210.494 204.392 203.721C203.633 196.948 204.392 38.8393 204.392 38.8393Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.596 127.583V124.427C296.597 124.164 296.547 123.903 296.447 123.659C296.348 123.416 296.201 123.194 296.015 123.007C295.83 122.82 295.609 122.672 295.366 122.571C295.123 122.47 294.862 122.418 294.598 122.418H250.36C249.638 122.418 248.946 122.131 248.436 121.622C247.926 121.112 247.64 120.42 247.64 119.699V115.459C247.64 114.738 247.926 114.046 248.436 113.536C248.946 113.026 249.638 112.74 250.36 112.74H294.78C295.309 112.74 295.816 112.53 296.191 112.157C296.566 111.783 296.777 111.277 296.779 110.748V107.323C296.78 106.983 296.869 106.648 297.036 106.35C297.203 106.053 297.444 105.804 297.735 105.626C298.026 105.448 298.358 105.348 298.699 105.335C299.04 105.322 299.378 105.396 299.682 105.551C299.72 105.57 299.757 105.593 299.791 105.619L312.981 115.484C313.296 115.657 313.559 115.912 313.741 116.222C313.924 116.532 314.019 116.885 314.017 117.244C314.015 117.603 313.917 117.956 313.731 118.264C313.546 118.572 313.281 118.824 312.964 118.994L299.595 129.311C299.556 129.341 299.513 129.368 299.469 129.39C299.164 129.539 298.825 129.607 298.486 129.589C298.146 129.571 297.817 129.466 297.529 129.285C297.242 129.105 297.005 128.853 296.842 128.555C296.678 128.257 296.594 127.923 296.596 127.583Z",
    fill: "url(#paint21_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.392 38.8393C204.392 38.8393 204.858 26.0716 219.627 25.063H253.084C253.084 25.063 233.771 28.1272 231.92 38.8393C230.069 49.5514 231.92 195.32 231.92 195.32C231.92 195.32 234.645 212.384 260.756 213.239H215.274C215.274 213.239 205.152 210.494 204.392 203.721C203.633 196.948 204.392 38.8393 204.392 38.8393Z",
    fill: "url(#paint22_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.375 210.252H193.427C190.029 210.252 187.274 213.007 187.274 216.406V220.37C187.274 223.769 190.029 226.524 193.427 226.524H495.375C498.773 226.524 501.528 223.769 501.528 220.37V216.406C501.528 213.007 498.773 210.252 495.375 210.252Z",
    fill: "#0047AB",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.375 210.252H193.427C190.029 210.252 187.274 213.007 187.274 216.406V220.37C187.274 223.769 190.029 226.524 193.427 226.524H495.375C498.773 226.524 501.528 223.769 501.528 220.37V216.406C501.528 213.007 498.773 210.252 495.375 210.252Z",
    fill: "url(#paint23_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.408 124.549L182.474 126.7C175.454 130.594 158.036 140.036 151.538 141.383C139.508 143.892 130.521 147.128 127.285 158.026C124.298 167.984 122.9 187.238 119.205 193.603L118.114 194.809L93.9814 196.827C93.9814 196.827 102.279 154.412 108.661 149.733C115.044 145.054 129.545 141.638 139.897 138.715C150.249 135.791 181.408 124.549 181.408 124.549Z",
    fill: "url(#paint24_linear_40_2296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.28 56.1226H421.77V91.6404H457.28V56.1226ZM452.287 86.6452H426.764V61.1172H452.287V86.6452Z",
    fill: "#A4C6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.534 65.5854H447.122V82.177H430.534V65.5854ZM370.128 56.1226H334.617V91.6404H370.128V56.1226ZM365.134 86.6452H339.611V61.1172H365.134V86.6452Z",
    fill: "#A4C6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.382 65.5854H359.97V82.177H343.382V65.5854ZM334.618 179.903H370.129V144.386H334.618V179.903ZM339.612 149.38H365.135V174.908H339.612V149.38Z",
    fill: "#A4C6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.382 153.848H359.97V170.44H343.382V153.848ZM427.698 129.894H404.032V153.566H427.698V129.894ZM422.704 148.571H409.026V134.89H422.704V148.571ZM401.35 69.4946H386.293V84.2076H391.287V74.4892H401.35V81.7102H395.89V86.7049H406.345V69.5053H411.663V89.9482H416.657V56.8442H411.663V64.5106H401.481V59.5917H396.487V64.5864H401.35V69.4946ZM392.036 106.283H400.786V101.288H397.03V94.9468H411.88V89.9516H392.036V106.283Z",
    fill: "#A4C6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.57 64.5865H392.775V59.5918H377.576V83.4583H382.57V64.5865ZM385.262 105.479V121.485H363.268V126.48H390.256V105.479H385.262Z",
    fill: "#A4C6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.683 126.067V116.577H381.114V111.582H355.809V106.831H350.932V101.953H345.938V106.948H350.815V111.826H355.689V126.067H360.683Z",
    fill: "#A4C6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.69 99.1134V104.109H360.336V108.905H369.346V95.2668H364.353V103.91H360.683V99.1134H355.69ZM377.019 104.567H381.658V92.2105H387.759V87.2153H376.664V104.45H372.025V109.446H377.019V104.567ZM353.312 132.055V127.06H348.435V113.248H343.441V127.457H348.318V132.055H353.312ZM403.978 129.954V124.959H399.059V115.73H411.132V110.735H394.066V124.959H398.984V129.954H403.978ZM407.07 101.288H412.064V106.282H407.07V101.288ZM452.834 149.295H457.828V154.289H452.834V149.295ZM434.626 126.8H439.62V131.794H434.626V126.8ZM451.962 96.4616H456.955V101.456H451.962V96.4616ZM400.493 158.479H405.487V163.474H400.493V158.479ZM410.54 171.634H415.534V176.629H410.54V171.634ZM431.378 164.003H436.372V168.998H431.378V164.003ZM413.368 138.947H418.362V143.942H413.368V138.947Z",
    fill: "#A4C6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.612 102.244H345.938V97.249H334.618V137.159H339.612V102.244ZM383.916 153.794V148.973H388.731V143.978H383.737V148.799H379.516V132.055H359.969V137.05H374.522V153.794H383.916ZM396.248 148.3V132.055H385.609V137.05H391.254V148.3H396.248ZM379.378 165.521H396.281V153.251H391.287V160.526H374.384V171.721H379.367V176.716H384.361V171.721H379.378V165.521Z",
    fill: "#A4C6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.758 180.68H392.751V176.629H406.566V171.634H387.758V180.68ZM409.338 124.956H423.474V101.611H443.884V109.448H429.619V126.8H434.613V114.443H443.884V124.96H448.877V101.456H444.036V96.6162H418.48V119.961H409.338V124.956Z",
    fill: "#A4C6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.873 113.208V132.577H442.809V144.26H447.8V149.255H452.794V144.26H447.803V137.571H457.866V113.208H452.873ZM445.311 156.929H440.317V175.692H444.961V180.47H449.955V175.475H445.311V156.929ZM448.579 167.598H452.531V180.47H457.524V162.603H448.579V167.598ZM436.372 150.302H443.156V145.307H431.378V160.381H436.372V150.302ZM425.199 159.766H408.926V164.761H420.205V180.5H436.481V175.505H425.199V159.766Z",
    fill: "#A4C6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.887 58.6117C322.735 58.6116 322.59 58.5512 322.482 58.4439C322.375 58.3365 322.315 58.1909 322.314 58.0391V43.3441C322.314 43.0279 322.57 42.7715 322.887 42.7715H337.579C337.727 42.7776 337.866 42.8406 337.969 42.9473C338.071 43.054 338.128 43.1962 338.128 43.3441C338.128 43.492 338.071 43.6342 337.969 43.7409C337.866 43.8476 337.727 43.9106 337.579 43.9167H323.459V58.0391C323.459 58.3558 323.203 58.6117 322.887 58.6117ZM337.579 192.791H322.887C322.735 192.791 322.59 192.731 322.482 192.623C322.375 192.516 322.315 192.37 322.314 192.219V177.524C322.314 177.448 322.329 177.374 322.358 177.304C322.387 177.235 322.429 177.172 322.482 177.119C322.535 177.066 322.598 177.023 322.668 176.995C322.737 176.966 322.812 176.951 322.887 176.951C322.962 176.951 323.037 176.966 323.106 176.995C323.175 177.023 323.239 177.066 323.292 177.119C323.345 177.172 323.387 177.235 323.416 177.304C323.445 177.374 323.459 177.448 323.459 177.524V191.646H337.579C337.656 191.643 337.733 191.655 337.806 191.683C337.878 191.71 337.944 191.752 338 191.805C338.055 191.859 338.1 191.923 338.13 191.994C338.16 192.065 338.176 192.142 338.176 192.219C338.176 192.296 338.16 192.373 338.13 192.444C338.099 192.515 338.055 192.579 337.999 192.632C337.943 192.686 337.877 192.727 337.805 192.755C337.733 192.782 337.656 192.794 337.579 192.791ZM469.676 58.6117C469.524 58.6116 469.379 58.5512 469.271 58.4439C469.164 58.3365 469.104 58.1909 469.103 58.0391V43.9167H454.984C454.836 43.9106 454.696 43.8476 454.594 43.7409C454.491 43.6342 454.434 43.492 454.434 43.3441C454.434 43.1962 454.491 43.054 454.594 42.9473C454.696 42.8406 454.836 42.7776 454.984 42.7715H469.675C469.827 42.7716 469.973 42.832 470.08 42.9393C470.187 43.0467 470.248 43.1923 470.248 43.3441V58.0391C470.248 58.1143 470.233 58.1888 470.205 58.2584C470.176 58.3279 470.134 58.3911 470.081 58.4443C470.028 58.4975 469.964 58.5396 469.895 58.5684C469.826 58.5971 469.751 58.6119 469.676 58.6117ZM469.676 192.791H454.984C454.836 192.785 454.697 192.722 454.594 192.615C454.492 192.509 454.435 192.366 454.435 192.219C454.435 192.071 454.492 191.928 454.594 191.822C454.697 191.715 454.836 191.652 454.984 191.646H469.104V177.524C469.104 177.448 469.119 177.374 469.147 177.304C469.176 177.235 469.218 177.172 469.272 177.119C469.325 177.066 469.388 177.023 469.457 176.995C469.527 176.966 469.601 176.951 469.676 176.951C469.752 176.951 469.826 176.966 469.895 176.995C469.965 177.023 470.028 177.066 470.081 177.119C470.134 177.172 470.176 177.235 470.205 177.304C470.234 177.374 470.249 177.448 470.249 177.524V192.219C470.249 192.37 470.188 192.516 470.081 192.624C469.973 192.731 469.828 192.791 469.676 192.791Z",
    fill: "#52BFFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_2296",
    x1: 111.929,
    y1: 117.724,
    x2: 137.791,
    y2: 119.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D1E4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9E4F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40_2296",
    x1: 224.765,
    y1: 280.034,
    x2: 225.442,
    y2: 296.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#68C8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#65C0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5DA9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#51839F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#405059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3D4D56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40_2296",
    x1: 267.234,
    y1: 278.335,
    x2: 267.917,
    y2: 295.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#68C8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#65C0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5DA9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#51839F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#405059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3D4D56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40_2296",
    x1: 416.481,
    y1: 272.36,
    x2: 417.158,
    y2: 289.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#68C8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#65C0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5DA9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#51839F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#405059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3D4D56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_40_2296",
    x1: 458.956,
    y1: 270.662,
    x2: 459.633,
    y2: 287.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#68C8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#65C0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5DA9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#51839F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#405059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3D4D56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_40_2296",
    x1: 186.674,
    y1: 131.026,
    x2: 201.923,
    y2: 136.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D1E4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9E4F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_40_2296",
    x1: 26.0913,
    y1: 283.072,
    x2: 34.9437,
    y2: 283.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A86C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_40_2296",
    x1: 146.006,
    y1: 289.637,
    x2: 154.572,
    y2: 282.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A86C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_40_2296",
    x1: 57.7489,
    y1: 195.461,
    x2: 78.3787,
    y2: 262.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_40_2296",
    x1: 85.1547,
    y1: 137.067,
    x2: 181.977,
    y2: 142.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_40_2296",
    x1: 363.054,
    y1: 40.8948,
    x2: 338.561,
    y2: 141.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_40_2296",
    x1: -82.972,
    y1: -47.2531,
    x2: 357.609,
    y2: 33.3794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_40_2296",
    x1: -62.6888,
    y1: 309.769,
    x2: 456.513,
    y2: 70.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_40_2296",
    x1: -19.1533,
    y1: 166.925,
    x2: 134.734,
    y2: 159.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_40_2296",
    x1: 28.3761,
    y1: 323.399,
    x2: 140.131,
    y2: 212.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_40_2296",
    x1: 192.559,
    y1: 106.099,
    x2: 126.095,
    y2: 228.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_40_2296",
    x1: 340.342,
    y1: -48.4425,
    x2: 356.649,
    y2: -47.1394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D1E4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9E4F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_40_2296",
    x1: 248.419,
    y1: 192.096,
    x2: 247.767,
    y2: 260.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_40_2296",
    x1: 438.168,
    y1: 193.903,
    x2: 437.517,
    y2: 262.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_40_2296",
    x1: 434.154,
    y1: 246.723,
    x2: 439.288,
    y2: 288.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_40_2296",
    x1: 246.395,
    y1: 248.721,
    x2: 246.395,
    y2: 287.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_40_2296",
    x1: 281.979,
    y1: 60.2164,
    x2: 280.512,
    y2: 131.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_40_2296",
    x1: 425.787,
    y1: 52.9667,
    x2: 130.246,
    y2: 157.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_40_2296",
    x1: 343.377,
    y1: 181.965,
    x2: 344.628,
    y2: 226.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_40_2296",
    x1: 2.2208,
    y1: 66.6985,
    x2: 140.727,
    y2: 162.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_2296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 524,
    height: 316,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranfer);
export default __webpack_public_path__ + "static/media/Tranfer.c621107217d9b1dd303d36d51be6d1d0.svg";
export { ForwardRef as ReactComponent };